import { FC } from 'react';
import { cn } from '@/shared/lib';
import { TranscriptChatMessage } from './TranscriptChatMessage';
import type { TranscriptPairedItem as TranscriptPairedItemType } from './utils';

type Props = {
  item: TranscriptPairedItemType;
};

/**
 * Параллельное отображение сессии перебивания: реплики говорящего A в одной колонке,
 * реплики перебивающего B — в соседней. Сторона A определяется его ролью
 * (клиент — слева, сотрудник — справа), B рендерится в противоположной колонке.
 */
export const TranscriptPairedItem: FC<Props> = ({ item }) => {
  const mainOnLeft = item.mainSide === 'left';

  const mainColumn = (
    <div className="flex flex-col gap-3 flex-1 min-w-0">
      {item.mainItems.map((msg) => (
        <TranscriptChatMessage key={msg.id} item={msg} />
      ))}
    </div>
  );

  const interruptingColumn = (
    <div className="flex flex-col gap-3 flex-1 min-w-0">
      {item.interruptingItems.map((msg) => (
        <TranscriptChatMessage key={msg.id} item={msg} />
      ))}
    </div>
  );

  return (
    <div className={cn('flex gap-3 w-full items-start')}>
      {mainOnLeft ? mainColumn : interruptingColumn}
      {mainOnLeft ? interruptingColumn : mainColumn}
    </div>
  );
};
